import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FeaturedProducts = ({ products, title = "" }) => {
  // Custom arrow components
  const NextArrow = ({ onClick }) => (
    <CarouselButton onClick={onClick} right>
      <FiChevronRight />
    </CarouselButton>
  );

  const PrevArrow = ({ onClick }) => (
    <CarouselButton onClick={onClick} left>
      <FiChevronLeft />
    </CarouselButton>
  );

  // Carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(4, products.length),
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, products.length),
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, products.length),
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <FeaturedProductsContainer>
      {title && <SectionTitle>{title}</SectionTitle>}
      <CarouselContainer>
        <Slider {...settings}>
          {products.map((product) => (
            <CarouselSlide key={product.id}>
              <ProductCard>
                <ProductImage src={product.image} alt={product.name} />
                <ProductInfo>
                  <h3>{product.name}</h3>
                  <Price>${product.price.toFixed(2)}</Price>
                  <Rating>
                    {"★".repeat(Math.floor(product.rating))}
                    {"☆".repeat(5 - Math.floor(product.rating))}
                  </Rating>
                </ProductInfo>
              </ProductCard>
            </CarouselSlide>
          ))}
        </Slider>
      </CarouselContainer>
    </FeaturedProductsContainer>
  );
};

// Styled Components
const FeaturedProductsContainer = styled.section`
  margin: 3rem 0;
`;

const SectionTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1f2937;
  text-align: center;
`;

const CarouselContainer = styled.div`
  position: relative;
  padding: 0 2rem;

  .slick-slide {
    padding: 0 10px;
    box-sizing: border-box;
  }

  .slick-dots {
    bottom: -30px;

    li button:before {
      color: #4f46e5;
      font-size: 10px;
    }

    li.slick-active button:before {
      color: #4f46e5;
    }
  }
`;

const CarouselButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 10;
  left: ${(props) => (props.left ? "0" : "auto")};
  right: ${(props) => (props.right ? "0" : "auto")};

  &:hover {
    background-color: #f3f4f6;
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 480px) {
    display: none !important;
  }
`;

const CarouselSlide = styled.div`
  outline: none;
`;

const ProductCard = styled.div`
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const ProductInfo = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Price = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: #4f46e5;
  margin-bottom: 0.5rem;
`;

const Rating = styled.div`
  color: #f59e0b;
  margin-bottom: 1rem;
  font-size: 0.9rem;
`;

export default FeaturedProducts;
